import QuinceLumina from "./QuinceLumina";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "quince-lumina",
  tipoEvento: "quince",
  tipoEtiqueta: "15 años",
  nombre: "Lumina",
  descripcion:
    "Diseño contemporáneo y juvenil: retrato en arco protagonista, tipografía editorial con itálicas grandes y ritmo delicado. En escritorio, texto y retrato conviven en una portada dividida.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    rosaEmpolvado: "/miniaturas/quince-lumina-rosaEmpolvado.jpg",
    champagne: "/miniaturas/quince-lumina-champagne.jpg",
    lavanda: "/miniaturas/quince-lumina-lavanda.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: QuinceLumina,
};
